module.exports = __webpack_public_path__ + "static/img/userinfo_bg.bd6ab7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/userinfo_bg.png
// module id = 6YAi
// module chunks = 54